import { render, staticRenderFns } from "./Lateral.vue?vue&type=template&id=6ce6d56a&"
import script from "./Lateral.vue?vue&type=script&lang=js&"
export * from "./Lateral.vue?vue&type=script&lang=js&"
import style0 from "./Lateral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports